/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import type { FC, ReactNode } from "react";
import { IoClose } from "react-icons/io5";

import { Button } from "../atoms/Button";

export interface PopupProps {
  icon?: ReactNode;
  title: string;
  body: string;
  onClose: () => void;
}

export const Popup: FC<PopupProps> = ({ icon, title, body, onClose }) => {
  return (
    <div
      className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-overlay-bg/80 z-50"
      onClick={onClose}
    >
      <div
        className="relative w-screen mx-2 my-6 p-6 flex flex-col gap-6 bg-white rounded-3xl overflow-hidden font-medium"
        onClick={(event) => event.stopPropagation()}
      >
        <IoClose
          className="absolute top-4 right-4 cursor-pointer text-tertiary-text"
          size={24}
          onClick={onClose}
        />
        <div className="flex gap-1.5 text-xl">
          {icon}
          {title}
        </div>
        {body}
        <Button variant="primary" label="Got it" onClick={onClose} />
      </div>
    </div>
  );
};
